module.exports = __webpack_public_path__ + "static/truckslider-07-min-9533b33f1d1215e7302546cc7e472487.jpg";